import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ButtonV2 } from '@eppendorf/vnls-react-components-preview';
import { type ReactElement } from 'react';

import { trackPendoEvent } from '$shared/tracking/trackPendoEvent';

import './copy-hash-cell.scss';

export interface CopyHashCellProps {
  hash: string;
  reportId: string;
  copiedHashReportId: string | null;
  onCopy: (hash: string, reportId: string) => Promise<void>;
}

export function CopyHashCell({
  hash,
  reportId,
  copiedHashReportId,
  onCopy,
}: CopyHashCellProps): ReactElement {
  if (copiedHashReportId === reportId) {
    return (
      <div className="flex flex__ai--center gap-s">
        <Icon
          name="success"
          size={IconSizeClasses.XSmall}
          className="bg-green-500 flex"
        />
        <span className="color-green-500 font-weight-bold">Copied</span>
      </div>
    );
  }

  return (
    <div className="copy-hash-cell flex flex__ai--center gap-s">
      <ButtonV2
        size="sm"
        variant="ghost"
        iconOnly
        onClick={(e) => e.stopPropagation()}
        onPress={() => {
          trackPendoEvent('copy-hash', { reportId });
          onCopy(hash, reportId);
        }}
        aria-label="Copy hash"
      >
        <Icon name="document-copy" size={IconSizeClasses.XSmall} />
      </ButtonV2>
      <span className="copy-hash-cell__text">{hash}</span>
    </div>
  );
}
